import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from "react-oidc-context";
import { UserProvider } from './context/UserContext';

async function bootstrap() {
  const res = await fetch('/config.json')
  if (!res.ok) {
    throw new Error('Failed to load runtime config')
  }

  const config = await res.json()
  const cognitoAuthConfig = config.cognitoConfig;

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <UserProvider>
        <App />
      </UserProvider>
    </AuthProvider>
    </React.StrictMode>
  );
}

bootstrap();
